module.exports = {
  breakpointDesktopMin: "1056px",
  breakpointTabletMax: "1055px",
  breakpointTabletMin: "768px",
  breakpointMobileMax: "767px",
};